module.exports = __webpack_public_path__ + "img/alta-costura.11c5be74.jpg";